Vue.component('ack-flow-resins', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-flow-resins',
	mixins: [languageMixins],
	created() {},
	mounted() {
		appLog.log('ack-flow-resins mounted');
		//this.setPageIsLoading(false)
	},
	props: {},
	computed: {
		...Vuex.mapGetters('resins', ['selectedFlowResinShopifyProduct']),
		...Vuex.mapState('resins', ['selectedFlowResinProductId']),
		...Vuex.mapGetters('localization', ['isUS_CA', 'isTW']),
		isMobile() {
			return this.$parent.isMobile;
		},
		isShowArrowIcon: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			pageId: 'flow-resins',
			selectedCard: null,
			default_3dps_bundle: 'shop-3dps-6',
			activeItem: null,
			flowResinsInfo: {
				title_section: {
					id: 'flow',
					title: 'resins.main_title',
					subtitle: 'resins.main_title',
					title_img:
						window.ackShopifyFileUrl("FLOW_logo.png"),
					description: 'resins.main_description',
					image_desktop:
						window.ackShopifyFileUrl("Website-V4.0-Flow_Top-banner_32869fc4-8c54-4d9e-9154-89c61ef31b1e.jpg"),
					image_mobile: null,
					price: 0.0,
					shop_button: 'resins.shop_button',
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
				},
				icons_section: {
					collateral_items: [
						{
							img_src:
								window.ackShopifyFileUrl("UVBox_V4_icon_1.png"),
							title: 'Flyer',
							// link: 'https://cdn.ackuretta.com/downloads/flow/Global_Digital_FLOW_Flyer.pdf?v=latest',
							link: 'https://s3.us-east-1.amazonaws.com/ackuretta.website/downloads/flow/Global_Digital_FLOW_Flyer.pdf',
						},
						{
							img_src:
								window.ackShopifyFileUrl("Resin_V4_icon_1Catalog.png"),
							title: 'Booklet',
							// link: 'https://cdn.ackuretta.com/public/curo/Digital_Application%20Booklet.pdf',
							link: 'https://s3.us-east-1.amazonaws.com/ackuretta.website/public/curo/Digital_Application+Booklet.pdf',
						},
						{
							img_src:
								window.ackShopifyFileUrl("Resin_V4_icon_5Shipping.png"),
							title: 'Shipping Restrictions',
							link: 'https://cdn.ackuretta.com/downloads/shipping-restriction/Shipping%20Restrictions.pdf',
						},
					],
				},
				product_menu_section: {
					menu_items: [
						{
							imageMenu:
								window.ackShopifyFileUrl("Resin_V4_Application_icon_1_C_B.png"),
							imageLogo:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Flow_Design_C_B.png"),
							id: 'cnb',
							productId: '6981479923815',
							link: '#cnb',
						},
						{
							imageMenu:
								window.ackShopifyFileUrl("Resin_V4_Application_icon_2_Splint.png"),
							imageLogo:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Flow_Design_Splint.png"),
							id: 'hard-splint',
							productId: '6981231870055',
							link: '#hard-splint',
						},
						{
							imageMenu:
								window.ackShopifyFileUrl("Resin_V4_Application_icon_3_Denture.png"),
							imageLogo:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Flow_Design_Denture.png"),
							id: 'denture',
							productId: '6981232066663',
							link: '#denture',
						},
					],
				},
				feature_section: {
					description: null,
					default_img:
						window.ackShopifyFileUrl("ALPHA_AI_V4_Orient_Stack___Nest.gif"),
					feature_items: [
						{
							title: 'resins.feature_section.feature_items.item_one.title',
							description: 'resins.feature_section.feature_items.item_one.description',
							link: '/blogs/news/read-before-buying-an-intraoral-scanner-for-dental-3d-printing',
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Workflow_Scan_70d3a7d2-359a-4e62-a038-23a0168e7df0.jpg"),
							open: true,
						},
						{
							title: 'resins.feature_section.feature_items.item_two.title',
							description: 'resins.feature_section.feature_items.item_two.description',
							link: '/blogs/news/best-dental-cad-3d-printing-software-to-kick-off-2023',
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Workflow_CAD_a8076199-a9eb-4537-96d2-9cfaaf58124d.jpg"),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_three.title',
							description: 'resins.feature_section.feature_items.item_three.description',
							link: '/blogs/news/alpha-ai-dental-3d-printing-slicing-software-what-s-new',
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Workflow_CAM_fc2950fb-fdfa-4c4d-b15a-17d17b262078.jpg"),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_four.title',
							description: 'resins.feature_section.feature_items.item_four.description',
							link: '/blogs/news/transforming-a-lab-with-the-ackuretta-sol-dental-3d-printer',
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Workflow_3D_Print_436a87dc-ac46-410e-8c40-ebe96e42bdcf.jpg"),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_five.title',
							description: 'resins.feature_section.feature_items.item_five.description',
							link: '/blogs/news/9-reasons-to-switch-to-the-cleani-washer',
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Workflow_Washing_06cdbaae-7d7f-4046-8b50-bfded278bc51.jpg"),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_six.title',
							description: 'resins.feature_section.feature_items.item_six.description',
							link: '/blogs/news/why-do-you-need-to-uv-cure-your-3d-printed-dental-application',
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Workflow_Curing_795ab752-80e7-49ba-a5e4-5ec9b9913d32.jpg"),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_seven.title',
							description: 'resins.feature_section.feature_items.item_seven.description',
							link: null,
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Workflow_Remove_support_563c6dc7-fe39-4fb6-8720-4c8062991769.jpg"),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_eight.title',
							description: 'resins.feature_section.feature_items.item_eight.description',
							link: null,
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Workflow_Assemble_26d034e1-2a9d-494a-87ba-77b384663c1c.jpg"),
							open: false,
						},
					],
				},
				trusted_brand_section: {
					collateral_items: [
						{
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Certification_Logo_1.png"),
							title: 'FDA',
						},
						{
							image:
								window.ackShopifyFileUrl("CE-mark.png"),
							title: 'CE',
						},
						{
							image:
								window.ackShopifyFileUrl("Website-V4.0-Flow_Certification_Logo_3.png"),
							title: 'Health Canada',
						},
					],
				},
				media_grid_section: {
					title: 'Successful Cases',
					media_grid_collection: {
						main_item: {
							title: 'Images provided by Dr. Yazid',
							description: '',
							img: window.ackShopifyFileUrl("Website-V4.0-Flow_Successful_Cases_1.jpg"),
						},
						secondary_item: {
							title: 'Images provided by Dr. Nakul Rathi',
							description: '',
							img: window.ackShopifyFileUrl("Website-V4.0-Flow_Successful_Cases_2.jpg"),
						},
					},
				},
				first_image_section: {
					title: 'Improved Formula for High-Performance Indications',
					image:
						window.ackShopifyFileUrl("Website-V4.0-Flow_Viscosity_Speed_Banner.jpg"),
					notes: '',
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		...Vuex.mapActions('resins', ['menuItemClick']),
		//...Vuex.mapActions('sliders', ['getSlideList'])

		onResinMenuItemClick(item) {
			this.menuItemClick(item.productId);
			this.selectedProductId = item.productId;
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
